<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 奖池管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="120px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="奖品类型" prop="awardStuffType">
                <el-select
                  v-model="searchform.awardStuffType"
                  placeholder="请选择奖品类型"
                  @change="getpoollist(searchform.awardStuffType)"
                >
                  <el-option
                    v-for="item in awardStuffTypelist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
           <el-col :span="6">
              <el-form-item label="选择奖品" prop="awardStuffUuid">
                <el-select v-model.trim="searchform.awardStuffUuid" placeholder="请选择奖励物品奖品池">
                  <el-option
                    v-for="item in awardStuffPoollist"
                    :key="item.awardStuffUuid"
                    :label="item.awardStuffName"
                    :value="item.awardStuffUuid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="search"
                v-permission="['supervise_select']"
              >搜索</el-button>
              <!-- <el-button type="primary" @click="add.addshow=!add.addshow">充值</el-button> -->
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!--步骤条 填写基础信息 -->
      <br />
      <add-prize :add="add" :search="search" />
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>{{title}}</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="orderno" label="图片" min-width="100">
              <template slot-scope="props">
                <el-image
                  style="width: 120px; height: 40px"
                  :src="imgsrc+props.row.receiptImageUrl"
                  :preview-src-list="[imgsrc+props.row.receiptImageUrl]"
                  fit="scale-down"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="awardInfuseValue"
              label="充值金额"
              min-width="100"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="receiptId" label="单据号" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="充值时间" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="state" label="状态" min-width="140" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.state"
                  active-color="#00A854"
                  :active-value="1"
                  inactive-color="#F04134"
                  :inactive-value="0"
                  @change="changeSwitch(scope.row,$event)"
                ></el-switch>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import AddPrize from "./components/AddPrize";
import { findlistbytypeandgroup } from "@/api/market/marketing";
import {
  logawardstuffinfuseupdateState,
  logawardstuffinfuseadd,
  selectByUuid,
  poolfindall
} from "@/api/market/pond";
export default {
  name: "paylist",
  components: { AddPrize },
  mounted() {
    this.getpoollist(0)
    //请求部门列表数据并且便利到表格
    this.search();
  },
  data() {
    return {
      //基础数据
      imgsrc:
        process.env.VUE_APP_BASE_API +
        "/mtscitech/back/filegetter/queryFile?fileType=image/jpeg&adress=",
      add: {
        addshow: false
      },
      awardStuffPoollist:[],
      //基础数据
      title: "充值记录",
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      codeVisible: false,
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
            awardStuffTypelist: [
        {
          value: 0,
          label: "红包"
        },
        {
          value: 1,
          label: "积分"
        },
        {
          value: 2,
          label: "实物"
        },
        {
          value: 3,
          label: "优惠卷"
        }
      ],
      searchform: {
        awardStuffType: 0,
        awardStuffUuid: null,
        state: 0,
        page: 1,
        pageSize: 10
      },
      value: true
    };
  },
  methods: {
        // 获取奖品列表
    getpoollist(awardType) {
      this.searchform.awardStuffUuid = "";
      findlistbytypeandgroup({ page: 1, rows: 200, awardType: awardType }).then(
        response => {
          this.awardStuffPoollist = response.data.rows;
        }
      );
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      selectByUuid(obj).then(response => {
        this.tableData = response.data.rows;
        this.packdate(this.tableData);
        this.total_count = response.data.total;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 拼数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {}
    },
    // 状态更新
    changeSwitch(row, state) {
      console.log(row);
      logawardstuffinfuseupdateState({
        uuid: row.logAwardStuffInfuseUuid,
        state: row.state
      }).then(response => {
          this.search()
      });
    },
    //搜索事件
    search() {
      this.currentPage = 1;
      this.Tabledata({
        state: this.searchform.state,
        awardStuffUuid: this.searchform.awardStuffUuid,
        page: 1,
        pageSize: this.searchform.pageSize
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage;
      this.Tabledata({
        keywords: this.searchform.keywords,
        userType: this.searchform.userType,
        beginTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        endTime:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        rows: this.searchform.pageSize,
        page: this.searchform.currPage
      });
      console.log(currPage);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
</style>